<template>
    <el-dialog title="定制服务详情" :visible.sync="dialogVisible" width="800px" :before-close="handleClose" :close-on-click-modal="false">
        <!-- 非合单 -->
        <template v-if="!orderInfo.tradeList">
            <div class="line-h-20">
                <div class="flex mt16">
                    <div>订单号：{{ orderInfo.tid }}</div>
                    <div class="ml25 flex-1">{{ orderInfo.receiveName }} <span class="ml4">{{ orderInfo.receiveMobile
                    }}</span><span class="ml4">{{ orderInfo.receiveCity | formatCity }}{{ orderInfo.receiveAddress }}</span></div>
                </div>
                <div class="flex mt8">
                    <div>买家留言：</div>
                    <div class="flex-1">{{ orderInfo.buyerFeedback }}</div>
                </div>
                <div class="flex mt8">
                    <div>卖家备注：</div>
                    <div class="flex-1">{{ orderInfo.sellerMemo }}</div>
                </div>
            </div>
            <div class="ml16 mr14" v-for="(item, index) in orderInfo.orderList" :key="index">
                <template
                    v-if="[...(item.freeEntryServiceInfo && JSON.parse(item.freeEntryServiceInfo) || []), ...(item.payEntryServiceInfo && JSON.parse(item.payEntryServiceInfo) || [])].length">
                    <el-table class="mt8"
                        :data="[...(item.freeEntryServiceInfo && JSON.parse(item.freeEntryServiceInfo) || []), ...(item.payEntryServiceInfo && JSON.parse(item.payEntryServiceInfo) || [])]"
                        style="width: 100%" :show-header="index == 0"
                        :span-method="(param) => spanMethod(param, [...(item.freeEntryServiceInfo && JSON.parse(item.freeEntryServiceInfo) || []), ...(item.payEntryServiceInfo && JSON.parse(item.payEntryServiceInfo) || [])])">
                        <el-table-column label="定制商品" width="180">
                            <template slot-scope="{row}">
                                <div class="flex">
                                    <div>
                                        <el-image style="width: 58px; height: 58px" :src="item.productImgUrl" fit="fill"
                                            :preview-src-list="[item.productImgUrl]"></el-image>
                                    </div>
                                    <div class="ml5 line-h-20">
                                        <div>{{ item.name }}/{{ item.shortName }}</div>
                                        <div>{{ item.quantity }}件</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="定制服务名称" width="180">
                            <template slot-scope="{row}">
                                <template v-if="row.n">
                                    {{ row.n }}
                                </template>
                                <template v-else-if="row.serviceName">
                                    {{ row.serviceName }}
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" label="定制服务描述">
                            <template slot-scope="{row}">
                                <template v-if="row.c">
                                    <span v-for="(content, contentIndex) in row.c" :key="contentIndex">
                                        <template v-if="content.split('^')[0] == 'text'">
                                            <template v-for="(textItem, textIndex) in content.split('^')[2].split(',')">
                                                <template v-if="contentIndex != 0">；</template>
                                                {{ textItem | formatText }}
                                            </template>
                                        </template>
                                        <template v-else="content.split('^')[0] == 'images'">
                                            <template v-for="imgItem in content.split('^')[2].split(',')">
                                                <el-image style="width: 58px; height: 58px" :src="imgItem" fit="fill"
                                                    :preview-src-list="content.split('^')[2].split(',')"></el-image>
                                            </template>
                                        </template>
                                    </span>
                                </template>
                                <template v-else-if="row.serviceAttriribute">
                                    {{ row.serviceAttriribute }}
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="单价">
                            <template slot-scope="{row}">
                                <template v-if="row.servicePrice">
                                    {{ row.servicePrice }}
                                </template>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>

            </div>
        </template>
        <!-- 合单 -->
        <template v-else>
            <div class="ml16 mr14" v-for="(item, index) in orderInfo.tradeList" :key="index">
                <template v-if="item.entryServiceFlag == 1">
                    <div class="line-h-20">
                        <div class="flex mt16">
                            <div>订单号：{{ item.tid }}</div>
                            <div class="ml25 flex-1">{{ item.receiveName }} <span class="ml4">{{ item.receiveMobile
                            }}</span><span class="ml4">{{ item.receiveCity | formatCity }}{{ item.receiveAddress }}</span></div>
                        </div>
                    </div>
                    <div class="mb8">
                        <div class="flex mt8">
                            <div>买家留言：</div>
                            <div class="flex-1">{{ item.buyerFeedback }}</div>
                        </div>
                        <div class="flex mt8">
                            <div>卖家备注：</div>
                            <div class="flex-1">{{ item.sellerMemo }}</div>
                        </div>
                    </div>
                    <template v-for="(orderItem, orderIndex) in item.orderList">

                        <!-- freeEntryServiceInfo：免费定制品,payEntryServiceInfo：收费定制品 -->
                        <template v-if="[...(orderItem.freeEntryServiceInfo && JSON.parse(orderItem.freeEntryServiceInfo) || []), ...(orderItem.payEntryServiceInfo && JSON.parse(orderItem.payEntryServiceInfo) || [])].length">
                            <el-table class="mt8"
                                :data="[...(orderItem.freeEntryServiceInfo && JSON.parse(orderItem.freeEntryServiceInfo) || []), ...(orderItem.payEntryServiceInfo && JSON.parse(orderItem.payEntryServiceInfo) || [])]"
                                style="width: 100%" :show-header="orderIndex == 0"
                                :span-method="(param) => spanMethod(param, [...(orderItem.freeEntryServiceInfo && JSON.parse(orderItem.freeEntryServiceInfo) || []), ...(orderItem.payEntryServiceInfo && JSON.parse(orderItem.payEntryServiceInfo) || [])])">
                                <el-table-column label="定制商品" width="180">
                                    <template slot-scope="{row}">
                                        <div class="flex">
                                            <div>
                                                <el-image style="width: 58px; height: 58px" :src="orderItem.productImgUrl"
                                                    fit="fill" :preview-src-list="[orderItem.productImgUrl]"></el-image>
                                            </div>
                                            <div class="ml5 line-h-20">
                                                <div>{{ orderItem.name }}/{{ orderItem.shortName }}</div>
                                                <div>{{ orderItem.quantity }}件</div>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="定制服务名称" width="180">
                                    <template slot-scope="{row}">
                                        <template v-if="row.n">
                                            {{ row.n }}
                                        </template>
                                        <template v-else-if="row.serviceName">
                                            {{ row.serviceName }}
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="定制服务描述">
                                    <template slot-scope="{row}">
                                        <template v-if="row.c">
                                            <span v-for="(content, contentIndex) in row.c" :key="contentIndex">
                                                <template v-if="content.split('^')[0] == 'text'">
                                                    <template
                                                        v-for="(textItem, textIndex) in content.split('^')[2].split(',')">
                                                        <template v-if="contentIndex != 0">；</template>
                                                        {{ textItem | formatText }}
                                                    </template>
                                                </template>
                                                <template v-else="content.split('^')[0] == 'images'">
                                                    <template v-for="imgItem in content.split('^')[2].split(',')">
                                                        <el-image style="width: 58px; height: 58px" :src="imgItem"
                                                            fit="fill"
                                                            :preview-src-list="content.split('^')[2].split(',')"></el-image>
                                                    </template>
                                                </template>
                                            </span>
                                        </template>
                                        <template v-else-if="row.serviceAttriribute">
                                            {{ row.serviceAttriribute }}
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="price" label="单价">
                                    <template slot-scope="{row}">
                                        <template v-if="row.servicePrice">
                                            {{ row.servicePrice }}
                                        </template>
                                        <span v-else>-</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>

                    </template>
                </template>
            </div>
        </template>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>

    </el-dialog>
</template>
<script>
export default {
    name: 'customizedServiceDetail',
    data() {
        return {
            dialogVisible: false,
        }
    },
    props: {
        orderInfo: {
            type: Object,
            default: () => { }
        }
    },
    components: {

    },
    filters: {
        formatText(text) {
            return text.replace(/\//g, '')
        },
        formatCity(text) {
            return text ? text.replace(/\,/g, ''): ''
        },
        
    },
    mounted() {
    },
    methods: {
        open() {
            this.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false;
        },
        spanMethod({ row, column, rowIndex, columnIndex }, data) {
            if (columnIndex === 0) {
                if (rowIndex == 0) {
                    return {
                        rowspan: data.length,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
    },
}

</script>
<style scoped lang="scss">
@import "../../../../styles/variables";


.flex {
    display: flex;
}

.flex-1 {
    flex: 1;
}

.bg-white {
    background: #fff;
}

.line-h-20 {
    line-height: 20px;
}

.mt8 {
    margin-top: 8px;
}

.mt16 {
    margin-top: 16px;
}

.ml16 {
    margin-left: 16px;
}

.mr14 {
    margin-right: 14px;
}

.mb8 {
    margin-bottom: 8px;
}

.ml4 {
    margin-left: 4px;
}

.ml5 {
    margin-left: 5px;
}

.ml25 {
    margin-left: 25px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 30px;
}
/deep/ .el-dialog__footer{
    text-align: center;
}
</style>